import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { CookieService } from 'ngx-cookie-service';

import { decryptString } from '../../../lib/cryptoJs';
import { TransferService } from '../../transferhistory/services/transferhistory.service';

@Component({
  selector: 'app-withdraw-staked-details',
  templateUrl: './withdraw-staked-details.component.html',
  styleUrls: ['./withdraw-staked-details.component.scss']
})
export class WithdrawStakedDetailsComponent {

  _id: any = ['']
  isLoading: boolean = false;
  withdrawData: any

  loader: boolean = false
  reason: string
  serverErrors: any = {}
  tokrn: any
  phoneNo: any = ''
  coinValue: any
  transactionId: any
  coinCurrentPrice: any
  usdtAmount: any

  //depositImageUrl = environment.walletApiUrl + 'deposit/'

  constructor(
    private service: TransferService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private cookieService: CookieService,
  ) { }
  ngOnInit(): void {
    this.tokrn = this.cookieService.get('admin_token')
    const id = this.route.snapshot.params['id']
    this._id = decryptString(id, true)

    this.getData();
  }


  getData() {


    this.isLoading = true
    this.service.getFiatDeposits(this._id, this.tokrn).subscribe({
      next: (v: any) => {
        this.isLoading = false
        this.withdrawData = v.data.docs[0]
        localStorage.setItem("xyzy", this.withdrawData.phoneNo)
        this.coinValue = this.withdrawData.coinValue
        this.transactionId = this.withdrawData.transactionId
        this.coinCurrentPrice = this.withdrawData.coinCurrentPrice
        this.usdtAmount = this.withdrawData.usdtAmount

      },
      error: (err) => {
        this.isLoading = false
      }
    });
  }
  approveCoinWithdraw() {
    this.loader = true
    this.service.approveWithdrawStake(this._id, 'approved', this.tokrn)
      .subscribe({
        next: (resp: any) => {
          this.loader = false
          const phoneno = localStorage.getItem('xyzy')
          if (resp.success) {
            this.toastr.success(resp.message)
            this.router.navigateByUrl('/deposite-commision')
          }
        },
        error: (err) => {
          this.loader = false
          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
            if (validationErrors) this.serverErrors = validationErrors || {};
            else this.toastr.error(err.error.message)
          } else if (err.status === 500) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  rejectCoinWithdraw() {
    this.loader = true
    this.service.approveWithdrawStake(this._id, 'rejected',this.tokrn)
      .subscribe({
        next: (resp: any) => {
          this.loader = false
          if (resp.success) {
            this.toastr.success(resp.message)
            this.router.navigateByUrl('/deposite-commision')
          }
        },
        error: (err) => {
          this.loader = false
          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
            if (validationErrors) this.serverErrors = validationErrors || {};
            else this.toastr.error(err.error.message)
          } else if (err.status === 500) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  redirectToUser() {
    window.history.back();
  }

}

